import React from "react";

const TokenTransferModal = ({ open, onClose, onSubmit, loading, tokenName, setTokenName, amount, setAmount }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center">
      <div className="bg-[#232323] rounded-3xl shadow-2xl border border-[#313D4F] p-8 flex flex-col items-center" style={{width: 350}}>
        <h2 className="text-2xl font-bold text-[#D9D9D9] mb-6 text-center">Token Transfer</h2>
        <form
          onSubmit={e => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <div className="mb-2">
            <label className="block text-[#A0AEC0] font-semibold mb-2">Token Name</label>
            <input
              type="text"
              className="px-4 py-2 rounded-lg bg-[#1E1E1E] text-[#F3F3F3] border border-[#313D4F] focus:outline-none focus:ring-2 focus:ring-blue-500 w-72"
              value={tokenName}
              onChange={e => setTokenName(e.target.value)}
              required
            />
          </div>
          <div className="mb-2">
            <label className="block text-[#A0AEC0] font-semibold mb-2">Amount</label>
            <input
              type="number"
              className="px-4 py-2 rounded-lg bg-[#1E1E1E] text-[#F3F3F3] border border-[#313D4F] focus:outline-none focus:ring-2 focus:ring-blue-500 w-72"
              value={amount}
              onChange={e => setAmount(e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'))}
              required
              min="0"
              step="any"
            />
          </div>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-6 rounded-full transition duration-200"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-bold py-2 px-6 rounded-full shadow-lg transition duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? "Transferring..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TokenTransferModal;
